module.exports = __webpack_public_path__ + "img/jf_home_16.9c5f7653.jpg";